// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"485":"game","521":"guide","549":"browser","870":"wishlist"}[chunkId] + "." + {"485":"9bc850ef","521":"c0b10b9c","549":"a935334e","870":"0f2435c3"}[chunkId] + ".css";
};